import { render, staticRenderFns } from "./Productlist.vue?vue&type=template&id=0c89fd97&scoped=true&"
import script from "./Productlist.vue?vue&type=script&lang=js&"
export * from "./Productlist.vue?vue&type=script&lang=js&"
import style0 from "./Productlist.vue?vue&type=style&index=0&id=0c89fd97&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c89fd97",
  null
  
)

export default component.exports